import {
    DynamicListAddButton,
    DynamicListWrapperProps,
    ValidatedDynamicList,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput
} from '@finbeat/react-toolkit';
import { SettingOrder, UnloadSetting, UnloadSettingCreate } from 'models/api/fundsTransfer';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Col, Row, Table } from 'reactstrap';

type OrderProps = ValidatedDynamicListFormComponentProps & {
    disabled: boolean;
};

const ModalFundsTransferSettingOrder = ({ disabled }: { disabled: boolean }) => {
    const FormComponent = useCallback(
        (props: ValidatedDynamicListFormComponentProps) => <Order {...props} disabled={disabled} />,
        [disabled]
    );
    const { watch } = useFormContext<UnloadSetting>();
    const UseOrders: boolean = watch('useOrders', false);
    if (UseOrders)
        return (
            <Row>
                <Col>
                    <ValidatedDynamicList<UnloadSettingCreate, SettingOrder>
                        wrapper={WrapperSettingOrder}
                        disabled={disabled}
                        emptyRecord={{
                            orderId: 0,
                        }}
                        name="orders"
                        formComponent={FormComponent}
                        compareFunc={(a, b) => a?.orderId === b?.orderId}
                    />
                </Col>
            </Row>
        );
    else return <Row></Row>;
};

const Order = ({ idx, fieldId, checkDouble, disabled }: OrderProps) => {
    const { t } = useTranslation();
    return (
        <td>
            <ValidatedInput<UnloadSetting>
                id="test"
                disabled={disabled}
                type="number"
                name={`orders.${idx}.orderId`}
                label={t('BackOfficeAppId')}
                rules={{
                    validate: () => checkDouble(fieldId) ?? undefined,
                }}
            />
        </td>
    );
};

const WrapperSettingOrder = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th>
                        <Trans i18nKey="BackOfficeAppId" />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

export default ModalFundsTransferSettingOrder;
